import { AxiosRequestConfig } from 'axios'
import md5 from 'md5'
import { AxiosFactory } from '@/utils/axios-factory'

function transformHeaders (config: any): any {
  const headers = config.headers
  const timestamp = new Date().getTime()
  const { appId, msgId, key } = window.config.auth
  headers.signature = md5(`${appId}${msgId}${key}${timestamp}`).toUpperCase()
  headers.appId = appId
  headers.msgId = msgId
  headers.timestamp = timestamp
  return headers
}

export const request = AxiosFactory({
  baseURL: '/iikb-app',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
}, {
  requestSuccess: (config: AxiosRequestConfig) => {
    if (window.config.auth.isNeedAuth) {
      config.headers = transformHeaders(config)
    }
    return config
  }
})
